import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { NavbarLayout } from '@/components/layouts/Navbar/NavbarLayout';
import { FirebaseAuthCard } from './FirebaseAuthCard';

export function getSafeRedirectPath(raw: string | null): string {
  if (!raw) {
    return '/';
  }
  try {
    const decoded = decodeURIComponent(raw);
    if (decoded.startsWith('/') && !decoded.startsWith('//')) {
      return decoded;
    }
  } catch {
    return '/';
  }
  return '/';
}

export const FirebaseAuth = () => {
  const [searchParams] = useSearchParams();

  const redirectPath = useMemo(
    () => getSafeRedirectPath(searchParams.get('redirectUrl')),
    [searchParams],
  );

  return (
    <>
      <NavbarLayout />
      <section
        className="flex flex-1 flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url("/background.svg")' }}
      >
        <div className="w-full max-w-2xl rounded-lg px-4 py-3 sm:px-8 sm:py-4">
          <FirebaseAuthCard redirectPath={redirectPath} />
        </div>
      </section>
    </>
  );
};
